import axios from 'axios';
import AppSettings from '../config';

const http = axios.create({
    baseURL: AppSettings.baseURL,
    withCredentials: true,
});

const PUBLIC_AUTH_PATHS = [
    '/auth/login',
    '/auth/signup',
    '/auth/register-patient',
    '/auth/whatsapp-otp',
    '/auth/verification-otp',
    '/auth/verify-contact',
    '/auth/validate-email-verification-token',
    '/auth/reset-password',
    '/auth/validate-reset-password-token',
    '/auth/update-password',
    '/auth/logout',
];

let onUnauthorized = null;
let handlingUnauthorized = false;

export const setUnauthorizedHandler = (handler) => {
    onUnauthorized = handler;
};

const requestPath = (config = {}) => {
    const url = `${config.baseURL || ''}${config.url || ''}`;
    try {
        return new URL(url, 'http://localhost').pathname;
    } catch (error) {
        return config.url || '';
    }
};

const isPublicAuthRequest = (config) => {
    const path = requestPath(config);
    return PUBLIC_AUTH_PATHS.some((item) => path.endsWith(item));
};

const isSessionError = (error) => {
    const status = error.response?.status;
    const data = error.response?.data || {};
    const message = String(data.message || '').toLowerCase();
    const path = requestPath(error.config);

    if (isPublicAuthRequest(error.config)) {
        return false;
    }

    if (data.code === 'SESSION_EXPIRED') {
        return true;
    }

    if (status !== 401 && status !== 403) {
        return false;
    }

    if (
        /token expired|invalid token|no such user|no token provided/.test(message)
    ) {
        return true;
    }

    return path.endsWith('/auth') || path.endsWith('/auth/');
};

http.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
    }
    return config;
});

http.interceptors.response.use(
    (response) => response,
    (error) => {
        if (onUnauthorized && isSessionError(error) && !handlingUnauthorized) {
            handlingUnauthorized = true;
            onUnauthorized(error);
            window.setTimeout(() => {
                handlingUnauthorized = false;
            }, 800);
        }
        return Promise.reject(error);
    },
);

export default http;
